import React, { useState } from 'react';
import { FeedbackModal } from './FeedbackModal';
import { Icon } from '../common/Icons';

export const FeedbackButton: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div className="fixed bottom-20 right-6 z-50 flex items-center justify-center lg:bottom-8 lg:right-8">
        {/* Pulsing ring effect */}
        <div className="absolute h-14 w-14 rounded-full border-2 border-blue-300 animate-pulse-ring" />
        <button
          onClick={() => setIsModalOpen(!isModalOpen)}
          className="relative flex h-14 w-14 items-center justify-center rounded-full bg-primary-600 text-white shadow-lg transition-all hover:bg-primary-700 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
          aria-label="Share feedback"
          title="Share your feedback, feature wishes, or report problems"
        >
          <Icon name="Feedback" size={24} className="text-blue-300 opacity-50" />
        </button>
      </div>
      <FeedbackModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};
